import { defineTokens } from "@chakra-ui/react-v3";

export const fonts = defineTokens.fonts({
  heading: {
    value:
      "'Geist Variable', 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Droid Sans', 'Helvetica Neue', sans-serif",
  },
  body: {
    value:
      "'Geist Variable', 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Droid Sans', 'Helvetica Neue', sans-serif",
  },
  mono: {
    value:
      "'Geist Mono Variable', source-code-pro, 'Menlo', 'Monaco', 'Consolas', 'Courier New', monospace",
  },
});

export const fontSizes = defineTokens.fontSizes({
  "2xs": { value: "0.625rem" },
  xs: { value: "0.75rem" },
  sm: { value: "0.875rem" },
  md: { value: "1rem" },
  lg: { value: "1.125rem" },
  xl: { value: "1.5rem" },
  "2xl": { value: "2rem" },
});

export const fontWeights = defineTokens.fontWeights({
  normal: { value: 400 },
  medium: { value: 500 },
  semibold: { value: 600 },
  bold: { value: 700 },
});

export const letterSpacings = defineTokens.letterSpacings({
  tighter: { value: "-0.01em" },
  tight: { value: "-0.005em" },
  normal: { value: "0em" },
  wide: { value: "0.05em" },
  wider: { value: "0.01em" },
  widest: { value: "0.09em" },
});

export const lineHeights = defineTokens.lineHeights({
  heading: { value: "1.2" },
  body: { value: "1.5" },
  mono: { value: "1.5" },
  tabs: { value: "1.25rem" },
});
